export const Work = [
    {
        id:1,
        name:"React Movie Database",
        description:"Website using React and The Movie DataBase API to display the latest movies available as well as information about the movie.",
        tags:["react","movies","styledComponents", "api"],
        
        demo:"https://ben-martinez-react-app.netlify.app/634649",
        github:"https://github.com/benmrtnz27/react"
    },
    {
        id: 2,
        name:"React Dictionary",
        description:"Webpage that utilizes the Google Dictionary API in order to search up words, display meanings, synonyms, and phonetics.",
        tags:["react","dictionary","materials-ui", "api"],
        
        demo:"https://benmrtnz-react-dictionary.netlify.app/",
        github:"https://github.com/benmrtnz27/reactdictionary"
    },
    {
        id:2,
        name:"Candy Crush Game",
        description:"Simple candy crush clone for the web browser using React. Saves and displays score",
        tags:["react","game"],
        
        demo:"https://benmrtnzcandycrush.netlify.app/",
        github:"https://github.com/benmrtnz27/CandyCrush"
        
    },
    {
        id:3,
        name:"Movie Review Classification",
        description:"A Sentiment Analysis project that analyzes a movie review to determine if it is positive or negative.",
        tags:["python","machine-learning","sentiment-analysis"],
        
        demo:"http://benmrtnz27.pythonanywhere.com/",
        github:"https://github.com/benmrtnz27/sentiment_analysis"
    },
    {
        id:4,
        name:"This Website!",
        description:"Built using React, framer, and multiple apis to create animated webpages that come to life.",
        tags:["javascript","react","api"],
        
        demo:"https://benmartinez.netlify.app/",
        github:"https://github.com/benmrtnz27/react-portfolio"
    },
    
  
] 